import React from "react"

import Layout from "../components/Layout"
import * as data from "../assets/js/data"
import { Link } from "gatsby"

const copy = {
  en: {
    title: "Canada Guide",
    closingText:
      "We hope this website is helpful to you as you settle in Canada. But there is no substitute for having a local friend to make you feel welcome.",
    closingHeading: "Meet local people at a church near you",
    disclaimer:
      "These webpages contain general information about personal finance, medical information and conditions, tax, and legal support for informational purposes only. The information is not financial, medical, tax or legal advice, and should not be taken as such.",
  },
  cn: {
    title: "加拿大指南",
    closingText:
      "我們希望這個網站能在你適應加拿大的過程中帶來幫助。不過，最能讓你真正感到被接納的，仍然是身邊關心你的本地朋友。",
    closingHeading: "在你附近的教會認識本地朋友",
    disclaimer:
      "本網站所提供的內容僅屬一般資訊，包括個人財務、醫療狀況與資訊、稅務及法律支援等，並不構成任何財務、醫療、稅務或法律意見，亦不應被視為此等專業意見。",
  },
}

const Guide = ({ lang }) => {
  const translate = key => copy[lang][key]
  const topics = data.topicCopy[lang]

  return (
    <Layout lang={lang}>
      <section className="header">
        <h1 className="info__header__title">{translate("title")}</h1>
      </section>
      <section className="information">
        {Object.entries(topics).map(([id, topic]) => (
          <a
            key={id}
            className="info__item"
            href={
              lang === "cn"
                ? `/cn/information/topic/?id=${id}`
                : `/information/topic/?id=${id}`
            }
            target="_blank"
            rel="noreferrer"
          >
            <div className={`info__item-image o__${id}`} />
            <div className="info__text">
              <h2 className="info__title">{topic.title}</h2>
              <h4 className="info__description">{topic.description}</h4>
            </div>
          </a>
        ))}
      </section>
      <br />
      <div className="index__item o__reverse o__blue">
        <div className="index__item-content">
          <p>{translate("closingText")}</p>
          <h2>{translate("closingHeading")}</h2>
        </div>
        <Link
          className="index__media o__local"
          to={lang === "cn" ? "/cn/connect/" : "/connect/"}
        />
      </div>
      <br />
      <p className="information__disclaimer">{translate("disclaimer")}</p>
    </Layout>
  )
}

export default Guide
